import src from "IMAGE";
export default { src, width: 126, height: 24, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AI7Kd/96wWD/g8Vq/2y6UP9nuEr/ablM/2a3SP9jtkX/AIrIc/97wWL/hcZs/3K9Vv9zvVf/cLxU/3C8VP9nuEn/P9IoqyV5PvkAAAAASUVORK5CYII="};
